export default __webpack_public_path__ + "static/media/walletConnect.26a8f490.png";